import { render, staticRenderFns } from "./modal-final-report.vue?vue&type=template&id=736c954a&"
import script from "./modal-final-report.vue?vue&type=script&lang=js&"
export * from "./modal-final-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports